module.exports = __webpack_public_path__ + "img/pow-microfibre.e46ddf3.png";